// @mui
import { alpha, styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  padding: theme.spacing(0.75, 2),
  margin: theme.spacing(0.5, 1),
  position: 'relative',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius * 1.5,
  transition: 'background-color 150ms ease, color 150ms ease, box-shadow 150ms ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  '&.active': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    fontWeight: theme.typography.fontWeightSemiBold,
    boxShadow: theme.shadows[1],
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '18%',
      height: '64%',
      width: 3,
      borderRadius: '0 3px 3px 0',
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  minWidth: 36,
  width: 22,
  height: 22,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
